import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAccepted: false,
};

const privacySlice = createSlice({
  name: 'privacy',
  initialState,
  reducers: {
    isAccepted: (state, action) => {
      state.isAccepted = action.payload;
    },
  }
});

export const { isAccepted } = privacySlice.actions;
export default privacySlice.reducer;

export const selectIsAccepted = (state) => state.privacy.isReviewing;